export default function HistoryCardLoading() {
    return (
        <div className="py-2.5  px-3 rounded-lg flex justify-between items-center bg-white/08 border-b border-white/08">
            <div className="flex items-center gap-3 w-[70%]">
                <div className="skeleton bg-white/08 rounded-lg flex-shrink-0 w-[28px] aspect-square"></div>

                <div className="flex flex-col gap-2 w-[80%]">
                    <p className="skeleton rounded-md w-[80%] h-3"></p>
                    <p className="skeleton rounded-md w-[50%] h-2 opacity-80"></p>
                </div>
            </div>

            <div className="flex flex-col items-end gap-2 w-[30%]">
                <span className="skeleton rounded-md w-[60%] h-3"></span>
                <p className="skeleton rounded-md w-[80%] h-2 opacity-80"></p>
            </div>
        </div>
    );
}
